<template>
	<b-container fluid class="mr-0 pr-0">
		<b-row no-gutters>
			<b-col cols="12" class="mb-4" v-for="(notice, index) in notices" :key="index">
				<b-card no-body footer-class="btn-gold text-white text-right p-0">
					<div>
						<div class="content-head">
							<h5 class="m-botton-0"><b>{{notice.title}}</b></h5>
							<h6>{{notice.sub_title}}</h6>
						</div>
						<div class="content-image">
							<img :src="notice.image_url" alt="imagen noticia">
						</div>
						<div class="content-description">
							<article v-html="notice.description" class="text-justify">
							</article>
							<b-modal :id="'modal-notice-'+index" title="Noticia" :hide-footer="true">
								<div class="body-modal">
									<h5 class="m-botton-0"><b>{{notice.title}}</b></h5>
									<h6>{{notice.sub_title}}</h6>
									<div class="content-image">
										<img :src="notice.image" alt="" style="height: 10em !important;">
									</div>
									<article class="">
										{{notice.description}}
									</article>
								</div>
							</b-modal>
							<br>
							<!-- <div class="footer-card m-top-2em">
								<h5 class="m-botton-0"><b>{{notice.title}}</b></h5>
								<h6>{{notice.sub_title}}</h6>
							</div> -->
						</div>
					</div>
					<template v-slot:footer>
						<b-link :href="notice.link" target="_blank" class="text-white">
							<div class="p-2">
								<b>VER MÁS</b>
							</div>
						</b-link>
					</template>
				</b-card>
			</b-col>
		</b-row>
	</b-container>
</template>
<script>
	export default {
		name: "notices",
		components: {
		},
		data() {
			return {
				notices: []
			}
		},
		filters: {
			truncate: function (text, length, suffix) {
				return text.substring(0, length) + suffix;
			},
		},
		mounted() {
			this.get_notices()
		},
		methods: {
			get_notices() {
				this.axios.get(process.env.VUE_APP_CUSTOMER_BACKEND+'notices', { baseURL: this.$store.state.customer_backend }).then(result => {
					this.notices = result.data
				}).catch(error => {
					console.log(error)
				});
			}
		}
	};
</script>
<style>
.height-6em {
	height: 6em;
}
.padding-1em-sides{
	padding: 0 1em;
}
.card-notice {
	background: #54504f !important;
	border-radius: 5px 5px;
}
.content-image img{
	width: 100% !important;
}
.content-head, article, .footer-card {
	padding: .5em 1em;
}
.show-more {
	text-align: right;	
	background: #b22322;
	padding: .1em;
}
</style> 